import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function salaryProjectReducer() {
    return combineReducers({
        BspPersReq_POx_PersInfo: createItemReducer("SalaryProject", "BspPersReq.POx_PersInfo", false),
        BspPersReq_POx_ListReq: createItemReducer("SalaryProject", "BspPersReq.POx_ListReq", false),
        BspPersReq_POx_ListReq_Params: createItemReducerParams("SalaryProject", "BspPersReq.POx_ListReq"),
        BspPersReq_POx_CalcReqAcion: createItemReducer("SalaryProject", "BspPersReq.POx_CalcReqAcion", false),
        BspPersReq_POx_ReqOne: createItemReducer("SalaryProject", "BspPersReq.POx_ReqOne", false)
    });
}